import Repository from "../../modules/services/Repository"


const reSource =  '/Statistics';


export default {
    get(data ){
        return Repository.get( `${reSource}` + data);
    },
}
